import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components';
import { RequirePasswordChangeGuard } from 'shared/guards/require-password-change.guard';
import { AnonymousGuard } from './guards/anonymous.guard';

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [AnonymousGuard],
        data: {
            pageTitle: 'generalKeywords.signin',
        },
    },
    {
        path: 'forgot-password',
        component: LoginComponent,
        canActivate: [AnonymousGuard],
        data: {
            pageTitle: 'generalKeywords.forgotPassword',
        },
    },
    {
        path: 'forgot-password/:requestId',
        component: LoginComponent,
        canActivate: [AnonymousGuard],
        data: {
            pageTitle: 'generalKeywords.resetPassword',
        },
    },
    {
        path: 'change-password',
        component: LoginComponent,
        canActivate: [RequirePasswordChangeGuard, AnonymousGuard],
        data: {
            pageTitle: 'generalKeywords.changePassword',
        },
    },
    {
        path: 'password-change-requested/:passwordChangeRequestId',
        component: LoginComponent,
        canActivate: [RequirePasswordChangeGuard, AnonymousGuard],
        data: {
            pageTitle: 'generalKeywords.changePassword',
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
